import { render } from "./patrol.html?vue&type=template&id=28acdea0&scoped=true&ts=true"
import script from "./patrol.ts?vue&type=script&lang=ts"
export * from "./patrol.ts?vue&type=script&lang=ts"

import "./patrol.scss?vue&type=style&index=0&id=28acdea0&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28acdea0"]])

export default __exports__